export default "__VITE_ASSET__CRkaWijm__"